import createReducer from '../../config/create_reducer';
import Const from '../../const';

const defaultState = {};

const handler = {
  [Const.wizard.payment.loading]: state => ({
    ...state,
    loading: true
  }),
  [Const.wizard.payment.loaded]: state => ({
    ...state,
    loading: false
  }),
  [Const.personalizedReading.loaded]: (state, { user }) => ({
    ...state,
    user: { ...state.user, ...user },
    loading: false
  }),
  [Const.wizard.payment.paymentProcessing]: (state, { value }) => ({
    ...state,
    paymentProcessing: value
  }),
  [Const.wizard.payment.setPaymentsParams]: (state, { paymentsParams }) => ({
    ...state,
    paymentsParams
  }),
  [Const.wizard.payment.setPaymentsData]: (state, { paymentsData }) => ({
    ...state,
    paymentsData
  }),
  [Const.wizard.payment.setPaymentsResponce]: (state, { paymentsResponce }) => ({
    ...state,
    paymentsResponce
  }),
  [Const.wizard.payment.clearPaymentsParams]: (state) => ({
    ...state,
    paymentsParams: null,
    paymentsData: null,
    paymentsResponce: null
  }),
  [Const.wizard.payment.setPaymentsCardData]: (state, { paymentsCardData }) => ({
    ...state,
    paymentsCardData
  }),
  [Const.wizard.payment.submitted]: (state, { value }) => ({
    ...state,
    submitted: value
  })
};

export default createReducer(defaultState, handler);
